import { getPricePlan, TPricePlan } from "apis/workspace/pricing-plan";
import React, { useEffect } from "react";
import AlertModal from "uis/modal/alert-modal";
import { MileMeetingPlan } from "uis/ServicePlan/ServicePlanCard/types";

interface RoomCreationLimitExceededModalProps {
  modalIsOpen: boolean;
  closeModal: () => void;
  plan?: number;
  countOfUsageRooms: number; //* INFO: 현재 사용중인 회의실 수
  limitOfUsageRooms: number; //* INFO: 사용 가능한 회의실 수
}

const RoomCreationLimitExceededModal: React.FC<RoomCreationLimitExceededModalProps> = ({
  modalIsOpen = false,
  closeModal,
  plan,
  countOfUsageRooms,
  limitOfUsageRooms,
}) => {
  const handlePlanInquiry = () => {
    window.open("https://mile.channel.io/home");
  };

  return (
    <AlertModal
      modalIsOpen={modalIsOpen}
      closeModal={closeModal}
      title={"생성 가능한 회의실 수를 초과하였습니다."}
      btnTitle="Mile에 문의하기"
      onChange={handlePlanInquiry}
      content={
        <p style={{ textAlign: "center" }}>
          <strong style={{ fontWeight: 700 }}>[현재 이용 중 플랜 및 생성 한도]</strong>
          <br />
          {plan === MileMeetingPlan.FREE
            ? "· 무료 플랜"
            : plan === MileMeetingPlan.PAID_NOT_TABLET
              ? "· 유료 플랜(태블릿 미사용)"
              : "· 유료 플랜(태블릿 사용)"}{" "}
          : {countOfUsageRooms}개 / {limitOfUsageRooms}개
        </p>
      }
    />
  );
};

export default React.memo(RoomCreationLimitExceededModal);
